import { useEffect, useState } from 'react';

export function ResponsivePaymentSuccessPage() {
  const [Component, setComponent] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    const loadComponent = async () => {
      const isMobile = window.innerWidth < 1024;
      
      if (isMobile) {
        const { PaymentSuccessPage } = await import('./payment/PaymentSuccessPage');
        setComponent(() => PaymentSuccessPage);
      } else {
        const { DesktopPaymentSuccessPage } = await import('./desktop/DesktopPaymentSuccessPage');
        setComponent(() => DesktopPaymentSuccessPage);
      }
    };
    
    loadComponent();
    
    // 결제 성공 페이지에서는 화면 크기 변경 대응 불필요
    // resize 이벤트 리스너 제거
  }, []);
  
  if (!Component) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
      </div>
    );
  }
  
  return <Component />;
}